import React, { useEffect } from 'react'
import jsCookie from 'js-cookie';
import {
  Navigate
} from 'react-router-dom';
import useAuthStore from '../store/auth';
import {
  useLocation
} from 'react-router-dom';

export default function Authenticated({ children }) {
  const location = useLocation();
  const clearAuth = useAuthStore((state) => state.clearAuth);
  // const authenticated = useAuthStore((state) => state.authenticated);

  const token = jsCookie.get('auth:token');
  
  useEffect(() => {
    if(!token || token == null || !token.length){
      clearAuth()
    }
  }, [token, clearAuth])
  
  //  const isAuthenticated = authenticated;
   return !token || token !== null ? children : < Navigate to = '/auth/sign-in'
   state = {
       {
     redirectFrom: location.pathname,
   }} / >
}
